import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { CheckCircle2 } from "lucide-react";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsletterForm = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(true);
  const [errors, setErrors] = useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    const next = {};
    if (!name.trim()) next.name = t("newsletter.form.error_name");
    if (!emailRegex.test(email.trim())) next.email = t("newsletter.form.error_email");
    if (!consent) next.consent = t("newsletter.form.error_consent");
    setErrors(next);
    if (Object.keys(next).length) return;
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={onSubmit}
      className="bg-white rounded-xl border border-slate-200 shadow-lg p-6 sm:p-8 space-y-5"
      data-testid="lead-form"
      noValidate
    >
      <div>
        <label htmlFor="nl-name" className="block text-sm font-semibold text-[#0F172A] mb-1.5">
          {t("newsletter.form.name_label")} <span className="text-[#B91C1C]">*</span>
        </label>
        <input
          id="nl-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("newsletter.form.name_placeholder")}
          className="w-full px-4 py-3 rounded-md border border-slate-300 focus:border-[#0B2545] focus:outline-none focus:ring-2 focus:ring-[#0B2545]/20 bg-white text-[#0F172A]"
          data-testid="input-name"
          autoComplete="name"
        />
        {errors.name && (
          <p className="mt-1.5 text-xs text-[#B91C1C]" data-testid="error-name">{errors.name}</p>
        )}
      </div>

      <div>
        <label htmlFor="nl-email" className="block text-sm font-semibold text-[#0F172A] mb-1.5">
          {t("newsletter.form.email_label")} <span className="text-[#B91C1C]">*</span>
        </label>
        <input
          id="nl-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("newsletter.form.email_placeholder")}
          className="w-full px-4 py-3 rounded-md border border-slate-300 focus:border-[#0B2545] focus:outline-none focus:ring-2 focus:ring-[#0B2545]/20 bg-white text-[#0F172A]"
          data-testid="input-email"
          autoComplete="email"
        />
        {errors.email && (
          <p className="mt-1.5 text-xs text-[#B91C1C]" data-testid="error-email">{errors.email}</p>
        )}
      </div>

      <label className="flex items-start gap-3 cursor-pointer text-sm text-[#475569]">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-1 w-4 h-4 accent-[#134E4A]"
          data-testid="input-consent"
        />
        <span>{t("newsletter.form.consent")}</span>
      </label>
      {errors.consent && (
        <p className="-mt-3 text-xs text-[#B91C1C]" data-testid="error-consent">{errors.consent}</p>
      )}

      <button
        type="submit"
        className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-[#0B2545] text-white text-base font-semibold hover:bg-[#0a1f3a] focus:outline-none focus:ring-4 focus:ring-[#0B2545]/25"
        data-testid="submit-button"
      >
        <CheckCircle2 className="w-5 h-5" />
        {t("newsletter.form.submit")}
      </button>
    </form>
  );
};

export default NewsletterForm;
